import { render, staticRenderFns } from "./TermoType.vue?vue&type=template&id=0a148ce5&"
import script from "./TermoType.vue?vue&type=script&lang=js&"
export * from "./TermoType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports